module.exports = __webpack_public_path__ + "img/player_bg.1f55d249.png";